import FlexibleDataOptimized from '@lib/cms/flexibleDataOptimized';
import FlexiblePage from '@templates/FlexiblePage';

import { screen_reader_title } from './styles.module.scss';

export async function getStaticProps(context) {
  const preview = context.preview || false;
  const previewEnv = context?.previewData?.environment ?? null;
  const data = await FlexibleDataOptimized.fetch('blog-landing', preview, previewEnv);

  return {
    props: { landingData: data, preview }
  };
}

const BlogLandingPage = ({ landingData, preview }) => {
  return (
    <div>
      <FlexiblePage data={landingData} preview={preview}>
        {/* The blog landing leads with a featured-post banner (no CMS heading
            block), so provide a screen-reader-only page-level <h1> for SEO and
            accessibility without altering the visual design. */}
        <h1 className={screen_reader_title}>Sibcy Cline Blog</h1>
      </FlexiblePage>
    </div>
  );
};

export default BlogLandingPage;
